<template>
  <v-card class="my-8 rounded-0 fill-height">
    <v-img src="../assets/bespoke.webp" aspect-ratio="16/9" height="300"></v-img>
    <v-card-title class="text-center">Skräddsydda AI program </v-card-title>
    <!-- display: block -->
    <v-card-text>
      Våra skräddarsydda program automatiserar era arbetsprocesser och frigör er tid för
      kärnverksamheten. Med avancerad AI-teknik skapar vi lösningar som passar era behov och ökar er
      effektivitet. Vi identifierar också var automatisering kan göra störst nytta.
    </v-card-text>
  </v-card>
</template>

<script>
export default {}
</script>
